import React, { createContext, useState, useContext, useEffect } from 'react';

// Erstelle den AuthContext
const AuthContext = createContext();

export const useAuth = () => {
    return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const storedUser = localStorage.getItem('user');
        return storedUser ? JSON.parse(storedUser) : null;
    });

    const [token, setToken] = useState(() => localStorage.getItem('token'));
    const [roleId, setRoleId] = useState(() => (user ? user.role_id : null));

    // Speichert Token, wenn es sich ändert
    useEffect(() => {
        if (token) {
            localStorage.setItem('token', token);
        } else {
            localStorage.removeItem('token');
        }
    }, [token]);

    // Speichert User-Daten, wenn sich der User ändert
    useEffect(() => {
        if (user) {
            localStorage.setItem('user', JSON.stringify(user));
        } else {
            localStorage.removeItem('user');
        }
    }, [user]);

    // Speichert role_id separat
    useEffect(() => {
        if (user && user.role_id) {
            setRoleId(user.role_id);
        }
    }, [user]);

    // Login-Funktion speichert User, Token und role_id
    const login = (userData, tokenData) => {
        setUser(userData);
        setToken(tokenData);
        setRoleId(userData.role_id);

        localStorage.setItem('token', tokenData);
        localStorage.setItem('user', JSON.stringify(userData));
    };

    // Funktion zum Ändern der `role_id` nach erfolgreichem Abo
    const updateUserRole = (newRoleId) => {
        if (user) {
            const updatedUser = { ...user, role_id: newRoleId };
            setUser(updatedUser);
            setRoleId(newRoleId);
            localStorage.setItem('user', JSON.stringify(updatedUser));
        }
    };

    // Logout-Funktion entfernt User, Token und role_id
    const logout = () => {
        setUser(null);
        setToken(null);
        setRoleId(null);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    };

    return (
        <AuthContext.Provider value={{ user, token, roleId, login, logout, updateUserRole }}>
            {children}
        </AuthContext.Provider>
    );
};
